import { render, staticRenderFns } from "./InstallerDealsDebts.vue?vue&type=template&id=96c28952&"
import script from "./InstallerDealsDebts.vue?vue&type=script&lang=js&"
export * from "./InstallerDealsDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports